import { DialogService } from "aurelia-dialog";
import { SafetySheetDialog } from "./dialogs/safety-sheet-dialog";
import { autoinject } from "aurelia-framework";

@autoinject()
export class Landing {

    constructor(private dialogService: DialogService) {
    }

    showSafetySheet() {
        this.dialogService.open(
            {
                viewModel: SafetySheetDialog
            });
    }
}